import { KeyboardEvent, MouseEvent } from 'react'
import { useSwiper } from 'swiper/react'
import { MdChevronLeft } from 'react-icons/md'

export const SlidePrevButton = () => {
  const swiper = useSwiper?.()

  const handlePrev = (event: MouseEvent | KeyboardEvent) => {
    event.stopPropagation()
    if (!swiper.destroyed) {
      swiper?.slidePrev?.()
    }
  }

  const handleKeyPressPrev = (event: KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.stopPropagation()
      handlePrev(event)
    }
  }
  return (
    <div
      data-testid="slide-prev-button"
      onClick={handlePrev}
      onKeyDown={handleKeyPressPrev}
      role="button"
      tabIndex={0}
      className="h-full w-[36px] flex items-center justify-center absolute top-0 left-0 z-[3] active:bg-transparent select-none active:select-none"
    >
      <MdChevronLeft className="text-white min-w-[24px] min-h-[24px]" />
    </div>
  )
}

export default SlidePrevButton
